








































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

export interface ICreateExamData {
  name?: string,
  passMark?: number,
  allowedFailures?: number,
  comments?: string
}

@Component
export default class AddExamModal extends Vue {
  @Prop({ default: false })
  visible!: boolean

  examData: ICreateExamData = {}

  isPercentage(v: string): string | true {
    const numInput = Number.parseFloat(v)
    if (numInput < 0 || numInput > 100) {
      return 'Must be between 0 and 100'
    }

    return true
  }

  isNumber(v: string): string | true {
    const numInput = Number.parseFloat(v)
    if (Number.isNaN(numInput)) {
      return 'Must be a valid number'
    }

    return true
  }

  required(v: any): string | true {
    return !!v || 'Field is required'
  }

  get output() {
    return {
      ...this.examData,
      passMark: ((this.examData || {}).passMark || 0) / 100
    }
  }

  submit() {
    if ((this.$refs.form as any).validate()) {
      this.$emit('submit', this.output)
    }
  }
}
